import { AnalyticsEvent, useAnalytics } from '@parcel2go/npm-p2g-app';
import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { GetAccountId } from '~/apps/smartsend/lib/helpers/AuthHelper';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

const useSmartSendAnalytics = () => {
  const { track } = useAnalytics();
  const { user } = useAuth();

  const trackEvent = useCallback(
    (event: AnalyticsEvent) => {
      track({
        ...event,
        payload: {
          ...GenerateBaseAnalyticsPayload([], event?.payload as Record<string, unknown>),
          accountNumber: GetAccountId(user?.profile)
        }
      });
    },
    [track, user?.profile]
  );

  return { track: trackEvent } as const;
};

export default useSmartSendAnalytics;
